import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { HOVERED_ICON_BUTTON_SX } from '../highContrastSx';

const ICON_BUTTON_SX = {
    width: 36,
    height: 36,
    color: 'grey.500',
    '&:focus': { color: 'grey.500' },
    '&:hover': { color: 'primary.main', ...HOVERED_ICON_BUTTON_SX },
};

const ICON_SX = {
    fontSize: 18,
};

const ROW_SX = {
    display: 'flex',
    gap: 0.5,
    alignItems: 'center',
};

const FACEBOOK_ITEM = {
    id: 'facebook',
    Icon: FacebookIcon,
};

const INSTAGRAM_ITEM = {
    id: 'instagram',
    Icon: InstagramIcon,
};

function SocialIcons({ links, labels }) {
    const items = [
        { ...FACEBOOK_ITEM, href: links.facebook, label: labels.facebook },
        { ...INSTAGRAM_ITEM, href: links.instagram, label: labels.instagram },
    ].filter(item => Boolean(item.href));

    if (items.length === 0) {
        return null;
    }

    return (
        <Box sx={ROW_SX} data-testid="redesign-footer-social">
            {items.map(item => (
                <IconButton
                    key={item.id}
                    component="a"
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.label}
                    sx={ICON_BUTTON_SX}
                    data-testid={`redesign-footer-social-${item.id}`}
                >
                    <item.Icon sx={ICON_SX} aria-hidden="true" />
                </IconButton>
            ))}
        </Box>
    );
}

SocialIcons.propTypes = {
    links: PropTypes.shape({
        facebook: PropTypes.string,
        instagram: PropTypes.string,
    }).isRequired,
    labels: PropTypes.shape({
        facebook: PropTypes.string.isRequired,
        instagram: PropTypes.string.isRequired,
    }).isRequired,
};

export default SocialIcons;
